module.exports = __webpack_public_path__ + "static/media/NotasFiscais1.fd55f249.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais1.png
// module id = 2132
// module chunks = 0